import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IngredientesCondimentosService {
  constructor(private httpClient: HttpClient) {}

  getIngredientesCondimentosLength(filter: string): Observable<any> {
    const queryParams = '?filter=' + filter;
    return this.httpClient.get(
      environment.apiURL +
        '/platos/ingredientes-condimentos-length' +
        queryParams
    );
  }
  getIngredientesCondimentos(
    currentPage: number,
    pageSize: number,
    filter: string
  ): Observable<any> {
    const queryParams =
      '?currentpage=' +
      currentPage +
      '&pagesize=' +
      pageSize +
      '&filter=' +
      filter;
    return this.httpClient.get(
      environment.apiURL + '/platos/ingredientes-condimentos' + queryParams
    );
  }
}
